import React, { useState, useEffect } from "react";
import axios from "axios";


const ProviderProfile = () => {
  // State to store user information
    const [user, setUser] = useState({
      name: "",
      contact_no: "",
      email: "",
      role: "",
      is_anonymous: "No", // Initial value from localStorage or backend
    });
  
    const [isUpdating, setIsUpdating] = useState(false); // Loading state
     const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  
    useEffect(() => {
      const storedUser = JSON.parse(localStorage.getItem("Login_User_Community_All_Data"));
      if (storedUser) {
        setUser({
          name: storedUser.name || "",
          contact_no: storedUser.contact_no || "",
          email: storedUser.email || "",
          role: storedUser.role || "",
          is_anonymous: storedUser.is_anonymous || "No", // Ensure correct initial value
        });
      }
    }, []);
  
    // Handle changes to editable fields
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setUser((prevUser) => ({
        ...prevUser,
        [name]: value,
      }));
    };
  
    // Toggle name display for patients
    const toggleNameDisplay = () => {
      setUser((prevUser) => ({
        ...prevUser,
        is_anonymous: prevUser.is_anonymous === "Yes" ? "No" : "Yes", // Toggle between "Yes" and "No"
      }));
    };
  
    const handleSave = async () => {
      try {
        setIsUpdating(true);
  
        // Prepare updated data
        const updatedData = {
          name: user.name,
          contact_no: user.contact_no,
          email: user.email,
          is_anonymous: user.is_anonymous, // Keep the toggled value
        };
  
        // Send the update request to the backend
        const response = await axios.put(`${API_BASE_URL}/api/users/3/update`, updatedData);
        console.log("API Response:", response.data);
  
        // Update localStorage with the new user data
        const updatedUser = {
          ...user,
        };
        localStorage.setItem("Login_User_Community_All_Data", JSON.stringify(updatedUser));
        alert("Profile updated successfully!");
      } catch (error) {
        console.error("Error updating profile:", error);
        alert("Failed to update profile. Please try again.");
      } finally {
        setIsUpdating(false);
      }
    };
  
    return (
      <div style={{ maxWidth: "100%", margin: "auto", padding: "20px", border: "1px solid #ccc", borderRadius: "10px" }}>
        <h2>Provider Profile</h2>
        <div>
          <label style={{ display: "block", marginBottom: "8px" }}>Name:</label>
          <input
            type="text"
            name="name"
            //value={user.displayNameAs === "Original" ? user.name : "Anonymous"}
            value={user.name}
            onChange={handleInputChange}
            //disabled={user.displayNameAs === "Anonymous"} // Disable input when name is "Anonymous"
            style={{ width: "100%", padding: "8px", marginBottom: "15px", border: "1px solid #ccc", borderRadius: "5px" }}
          />
        </div>
        <div>
          <label style={{ display: "block", marginBottom: "8px" }}>Contact Number:</label>
          <input
            type="text"
            name="contact_no"
            value={user.contact_no}
            onChange={handleInputChange}
            style={{ width: "100%", padding: "8px", marginBottom: "15px", border: "1px solid #ccc", borderRadius: "5px" }}
          />
        </div>
        <div>
          <label style={{ display: "block", marginBottom: "8px" }}>Email:</label>
          <input
            type="text"
            name="email"
            value={user.email}
            onChange={handleInputChange}
            disabled
            style={{ width: "100%", padding: "8px", marginBottom: "15px", border: "1px solid #ccc", borderRadius: "5px" }}
          />
        </div>
        <div>
          <label style={{ display: "block", marginBottom: "8px" }}>Role:</label>
          <input
            type="text"
            value={
              user?.role === "1"
                ? "Admin"
                : user?.role === "2"
                ? "Patient"
                : user?.role === "3"
                ? "Provider"
                : user?.role === "4"
                ? "Vendor"
                : "Unknown"
            }
            disabled
            style={{ width: "100%", padding: "8px", marginBottom: "15px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: "#f9f9f9" }}
          />
        </div>
        {user.role === "2" && (
          <div style={{ marginBottom: "15px" }}>
            <label style={{ display: "block", marginBottom: "8px" }}>Display Name As:</label>
            <button onClick={toggleNameDisplay} style={{ padding: "8px 15px", cursor: "pointer" }}>
              {user.is_anonymous === "Yes" ? "Switch to Original" : "Switch to Anonymous"}
            </button>
          </div>
        )}
        <button
          onClick={handleSave}
          style={{
            padding: "10px 20px",
            backgroundColor: isUpdating ? "#ccc" : "#28a745",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: isUpdating ? "not-allowed" : "pointer",
          }}
          disabled={isUpdating}
        >
          {isUpdating ? "Saving..." : "Save"}
        </button>
      </div>
    );
}

export default ProviderProfile